import * as baseConfig from './config.base.json';
import * as environmentConfig from './config.json';

export const microsoftClarityConfiguration = {
    ...baseConfig,
    ...environmentConfig
};
